module.exports = __webpack_public_path__ + "oktaVerify_38x38.d4d0c9c9d47b7a82ffcc9bf53269d16a.png";